// Pause / resume seasonal animations (snippets/event-ambient.liquid). The choice lasts for the visit.
(() => {
  const STORAGE_KEY = 'event-motion-paused';
  const button = document.querySelector('[data-event-motion-toggle]');
  if (!button) return;

  const apply = (paused) => {
    document.documentElement.classList.toggle('event-motion-paused', paused);
    button.setAttribute('aria-pressed', String(paused));
  };

  let paused = false;
  try {
    paused = sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (error) {
    // Storage blocked: start unpaused.
  }
  apply(paused);

  button.addEventListener('click', () => {
    paused = !paused;
    apply(paused);
    try {
      sessionStorage.setItem(STORAGE_KEY, paused ? '1' : '0');
    } catch (error) {
      // Storage blocked: the choice still applies to this page.
    }
  });
})();
